// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/actionable_error.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/actionable_error.proto.
 */
export const file_gitpod_v1_actionable_error: GenFile = /*@__PURE__*/
  fileDesc("CiBnaXRwb2QvdjEvYWN0aW9uYWJsZV9lcnJvci5wcm90bxIJZ2l0cG9kLnYxIt8BChZBY3Rpb25hYmxlRXJyb3JEZXRhaWxzEhIKCmVycm9yX2NvZGUYASABKAkSFAoMdXNlcl9tZXNzYWdlGAIgASgJEkEKCG1ldGFkYXRhGAMgAygLMi8uZ2l0cG9kLnYxLkFjdGlvbmFibGVFcnJvckRldGFpbHMuTWV0YWRhdGFFbnRyeRInCgdhY3Rpb25zGAQgAygLMhYuZ2l0cG9kLnYxLkVycm9yQWN0aW9uGi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJrCgtFcnJvckFjdGlvbhIRCglhY3Rpb25faWQYASABKAkSDQoFbGFiZWwYAiABKAkSGAoOZGFzaGJvYXJkX3BhdGgYAyABKAlIABIWCgxleHRlcm5hbF91cmwYBCABKAlIAEIICgZ0YXJnZXRCLFoqZ2l0aHViLmNvbS9naXRwb2QtaW8vZ2l0cG9kLW5leHQvYXBpL2dvL3YxYgZwcm90bzM");

/**
 * ActionableErrorDetails provides structured error information that can be
 * attached to any Connect RPC error via err.AddDetail(). The frontend uses
 * this to render actionable UI (buttons, links, guidance) instead of raw
 * error strings.
 *
 * This is a standalone detail message — it does not modify the environment
 * status proto or any existing message. It follows the same pattern as
 * ParseContextURLPreconditionFailureDetails and PolicyEnforcedFailedPreconditionDetails.
 *
 * @generated from message gitpod.v1.ActionableErrorDetails
 */
export type ActionableErrorDetails = Message<"gitpod.v1.ActionableErrorDetails"> & {
  /**
   * Machine-readable error code for programmatic handling.
   * Convention: COMPONENT_CATEGORY_SPECIFIC (e.g. CONTENT_GIT_ACCESS_DENIED).
   *
   * @generated from field: string error_code = 1;
   */
  errorCode: string;

  /**
   * Human-readable message for end-users, replacing the raw error string.
   *
   * @generated from field: string user_message = 2;
   */
  userMessage: string;

  /**
   * Domain-specific metadata relevant to this error type.
   * Keys are domain-specific (e.g. "git_host", "repository_url", "policy_name").
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };

  /**
   * Actions the user can take to resolve the error.
   *
   * @generated from field: repeated gitpod.v1.ErrorAction actions = 4;
   */
  actions: ErrorAction[];
};

/**
 * Describes the message gitpod.v1.ActionableErrorDetails.
 * Use `create(ActionableErrorDetailsSchema)` to create a new message.
 */
export const ActionableErrorDetailsSchema: GenMessage<ActionableErrorDetails> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_actionable_error, 0);

/**
 * ErrorAction describes a single action a user can take to resolve an error.
 *
 * @generated from message gitpod.v1.ErrorAction
 */
export type ErrorAction = Message<"gitpod.v1.ErrorAction"> & {
  /**
   * Machine-readable action identifier (e.g. "configure_git_auth", "view_docs").
   *
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * Human-readable button label (e.g. "Configure Git Authentication").
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Navigation target for this action.
   *
   * @generated from oneof gitpod.v1.ErrorAction.target
   */
  target: {
    /**
     * Internal dashboard route (e.g. "/settings/git-authentication").
     *
     * @generated from field: string dashboard_path = 3;
     */
    value: string;
    case: "dashboardPath";
  } | {
    /**
     * External URL (e.g. "https://ona.com/docs/...").
     *
     * @generated from field: string external_url = 4;
     */
    value: string;
    case: "externalUrl";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.ErrorAction.
 * Use `create(ErrorActionSchema)` to create a new message.
 */
export const ErrorActionSchema: GenMessage<ErrorAction> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_actionable_error, 1);

